module.exports = __webpack_public_path__ + "img/body_red_green.5b036d50.png";